/** Extract oral-exam join error code from ApiClientError or AxiosError bodies. */
export function getJoinErrorCode(err: unknown): string | undefined {
  if (typeof err !== 'object' || err === null) return undefined;
  const obj = err as Record<string, unknown>;
  const nestedData = (obj?.response as Record<string, unknown> | undefined)
    ?.data as Record<string, unknown> | undefined;
  const nestedError = nestedData?.error as Record<string, unknown> | undefined;
  if (typeof nestedError?.code === 'string') return nestedError.code;
  if (typeof obj.code === 'string') return obj.code;
  return undefined;
}
